import { MasterHelper } from '../../utilities';
import { RegulationFilterViewModel } from './regulation.model';
import { RegulationDetailType } from './regulation-detail-type';
import { LibraryType } from 'src/app/core/enums/regulator/regulator-status';

export class RegulationFilterModel {
  Id: number | null;
  UserId: number | null;
  FromDate: string=MasterHelper.getDateStr(7); 
  ToDate: string=MasterHelper.getDateStr(0);
  MappingID: string[] | null;
  Regulator: string[] | null;
  Status: string[] | null;
  RegulationId: number[];
  Jurisdictions: string[];
  Country: string[];
  DetailType: RegulationDetailType;
  FilterType: string;
  regulationLibraryId: number;
  regulationLibraryType: LibraryType;

  SearchQuery: string[];
  Filters: RegulationFilterViewModel;
  SortKey: string | null;
  IsDesc: boolean | true;
  TakeCount: number;
  SkipCount: number;
  TotalItems: number | null;
  IsAdvance: boolean;
  PageSize: number;
  Page: number;
  divisionId: number;
  Geography: string[];
  IsTrendingDashboard: boolean | false;
  GroupBy: "PubType" | "Country" | "MappingId";
  ReferenceDate: string | null;
  IsSimilarId: boolean | false;
  SimilarIdFor:number;
  constructor() {
    this.GroupBy = 'MappingId';
    this.Id = null;
    this.UserId = null;
    this.FromDate = MasterHelper.getDateStr(7);
    this.ToDate = MasterHelper.getDateStr(0);
    this.MappingID = [];
    this.Regulator = null;
    this.Status = null;
    this.RegulationId = [];
    this.Jurisdictions = [];
    this.Country = [];
    this.DetailType = RegulationDetailType.Regulation;
    this.FilterType = '';
    this.regulationLibraryId = 0;
    this.regulationLibraryType = LibraryType.Unknown;

    this.SearchQuery = [];
    this.Filters = new RegulationFilterViewModel();
    this.SortKey = null;
    this.IsDesc = true;
    this.TakeCount = 0;
    this.SkipCount = 0;
    this.TotalItems = null;
    this.IsAdvance = false;
    this.PageSize = 50;
    this.Page = 1;
    this.divisionId = 0;
    this.Geography = [];
    this.IsTrendingDashboard = false;
    this.ReferenceDate = MasterHelper.getCurrrentDateTime('YYYY-MM-DDTHH:mm:ssZ');
    this.IsSimilarId = false;
    this.SimilarIdFor = 0;
  }
}
export class GroupingModel {
  UserId!: number;
  GroupBy: "Country" | "PubType" | "MappingId"
  FromDate: string | null   //2022-02-01
  ToDate: string | null  //2022-02-28
  DivisionId!: number;
  RegulationLibraryId!: number;
  RegulationLibraryType!: LibraryType;
  FilterType: string   // Open
  Status: string[]
  RegulationId: number[]
  IsTrendingDashboard: boolean
  Country: string[]
  Geography: string[]
  SearchQuery: string[]
  MappingID: string[]
  Filters: RegulationFilterViewModel
  ReferenceDate: string | null;
  IsSimilarId: boolean | false;
  SimilarIdFor:number;
  constructor() {
    this.GroupBy = 'Country';
    this.FromDate = MasterHelper.getDateStr(7);
    this.ToDate = MasterHelper.getDateStr(0);
    this.MappingID = [];
    this.Status = [];
    this.RegulationId = [];
    this.Country = [];
    this.FilterType = '';

    this.SearchQuery = [];
    this.Filters = new RegulationFilterViewModel();
    this.Geography = [];
    this.IsTrendingDashboard = false;
    this.ReferenceDate = MasterHelper.getCurrrentDateTime('YYYY-MM-DDTHH:mm:ssZ');
    this.IsSimilarId = false;
    this.SimilarIdFor = 0;
  }
}
